import React, { useCallback } from "react";
import { Tag as PolarisTag } from "@medentic/polaris-react";
import { getBackgroundByName, getTextColorByName } from "../SwatchColorPicker/swatchColors";
import "./Tag.scss";

interface TagProps {
  tagLabel: string;
  colorName?: string;
  tagId?: string;
  onRemove?: (tagId: string) => void;
}

const Tag: React.FC<TagProps> = ({ tagLabel, onRemove, colorName, tagId }) => {
  const backgroundColor = getBackgroundByName(colorName ?? "");
  const textColor = getTextColorByName(colorName ?? "");
  const tagStyle: React.CSSProperties & Record<"--tag-bg" | "--tag-color", string> = {
    "--tag-bg": backgroundColor ?? "#e4e5e7",
    "--tag-color": textColor ?? "#000",
  };

  const handleRemove = useCallback(() => {
    if (onRemove) {
      onRemove(tagId ?? "");
    }
  }, [onRemove, tagId]);

  return (
    <div className="tag-wrapper" style={tagStyle}>
      <PolarisTag onRemove={onRemove ? handleRemove : undefined}>
        {tagLabel}
      </PolarisTag>
    </div>
  );
};

export default Tag;
